module.exports = __webpack_public_path__ + "static/media/Avatar_7.d63bedd8.svg";